const clientName = import.meta.env.VITE_CLIENT_DETAIL?.name;

export const CLIENT_HEADER_LEFT_CONTENT = [
  { title: 'Quick Menu', name: 'hamburger_menu' },
  { title: 'Backward', name: 'backward_icon' },
  { title: 'Forward', name: 'forward_icon' },
  { title: 'Refresh', name: 'reload' },
];
export const CLIENT_HEADER_RIGHT_CONTENT = [
  { title: `${clientName} apps switch`, name: 'app_switch' },
  { title: 'Minimize', name: 'window_minimize' },
  { title: 'Restore', name: 'window_restore' },
  { title: 'Close', name: 'close' },
];

export const CLIENT_HEADER_APP_SWITCH = [
  { title: `${clientName} apps switch`, name: 'app_switch' },
];

export const helpHeaderItems = [
  {
    label: 'NLP HELP',
    path: '/nlp',
  },
];
